import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  DashboardFilters,
  DEFAULT_DASHBOARD_FILTERS,
} from '@partner/feature-modules/dashboard/domain/model/dashboard-filters.model';
import { StateService } from 'common';

@Injectable({ providedIn: 'root' })
export class DashboardFiltersStateService extends StateService<DashboardFilters> {
  constructor() {
    super(DEFAULT_DASHBOARD_FILTERS);
  }

  getFilters$(): Observable<DashboardFilters> {
    return this.select((state: DashboardFilters) => state);
  }

  /** Current snapshot, for building the next immutable state. */
  getFilters(): DashboardFilters {
    return this.state;
  }

  setFilters(filters: DashboardFilters): void {
    this.setState(filters);
  }
}
